import styled from '@emotion/styled'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Breakpoint from '../../Breakpoint'
import Container from '../../components/global/Container'
import Section from '../../components/global/Section'
import Title from '../../components/global/Title'
import { useLangSelected } from '../../hooks/useLangSelected'

const Contact = () => {
    const lng = useLangSelected()
    const { t } = useTranslation('translation')

    return (
        <Container>
            <Section>
                <Title>{t('page.contact.title')}</Title>
                <NoticeMessage>
                    <p>💡 Vous avez une question et souhaitez nous contacter ?</p>
                    <p>
                        Il se peut que la réponse à votre question se trouve déjà sur notre{' '}
                        <Link to={`/${lng}/faq`}>FAQ</Link>.
                    </p>
                    <p>
                        Par ailleurs, les horaires ainsi que les types de séance sont indiqués sur la page{' '}
                        <Link to={`/${lng}/horaires-et-tarifs`}>Horaires & tarifs</Link>.
                    </p>
                    <p>Vous y trouverez aussi le prix des différentes licences pour rejoindre notre club.</p>
                </NoticeMessage>
                <ContactInfoContainer>
                    <InfoContainer>
                        <FontAwesomeIcon icon={faEnvelope} />
                        <InfoItem>contact@bva-club.fr</InfoItem>
                    </InfoContainer>
                    <InfoContainer>
                        <FontAwesomeIcon icon={faPhone} />
                        <img
                            alt=""
                            src="https://scontent-cdg4-2.xx.fbcdn.net/v/t39.30808-1/240824895_10220790694663244_2615772483876422545_n.jpg?stp=dst-jpg_s160x160&amp;_nc_cat=101&amp;ccb=1-7&amp;_nc_sid=0ecb9b&amp;_nc_ohc=wZM-493mF84Q7kNvgFc3j25&amp;_nc_ht=scontent-cdg4-2.xx&amp;_nc_gid=AEcU4LuHXgKi527-ebr4fsK&amp;oh=00_AYA0fFvwlZgiGJBBpMJ8KgKG9eSOTWZ5PQ0j81kwsgbbtw&amp;oe=66E7A4FD"
                        />
                        <TelWrapper>
                            Equipe BVA :&nbsp; <InfoItem>06 28 36 25 52</InfoItem>
                            <br />
                        </TelWrapper>
                    </InfoContainer>
                </ContactInfoContainer>
            </Section>
        </Container>
    )
}

const TelWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const NoticeMessage = styled.div`
    background-color: #f8f9fa;
    border-left: 4px solid #ffc107;
    padding: 16px;
    margin: 24px 0;
    border-radius: 4px;
    font-size: 0.95rem;
    color: #495057;
    margin-left: auto;
    margin-right: auto;

    p {
        margin: 0.5rem 0;
        line-height: 1.5;
    }
`

const ContactInfoContainer = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    min-height: 300px;
    margin-top: 2rem;

    @media (max-width: ${Breakpoint.TABLET_L}) {
        flex-direction: column;
        height: auto;
        margin-top: 16px;
    }
`

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 250px;

    & div {
        font-family: 'Roboto Semi Bold';
        color: var(--primary-color);
        font-size: 2.2rem;
        margin-bottom: 8px;
    }

    & .fa-envelope,
    & .fa-phone {
        color: var(--primary-color);
        font-size: 6.2rem;
        margin-bottom: 16px;
    }

    @media (max-width: ${Breakpoint.TABLET_L}) {
        margin-bottom: 32px;
        height: auto;
    }
`

const InfoItem = styled.div`
    font-family: 'Roboto Semi Bold';
    color: black !important;
`

export default Contact
